<template>
  <div>
    <div v-if="isLoading" class="loading-overlay"
      style="display: flex; justify-content: center; align-items: center; height: 100vh;">
      <van-loading size="32px" color="#1989fa" class="spinning">加载中...</van-loading>
    </div>
    <div v-else style="padding: 0px 20px 60px 20px;">
      <h2>{{ news.title }}</h2>
      <div class="detail-right">{{ news.orgName }}</div>
      <div class="detail-right">{{ news.releaseTime }}</div>
      <div v-html="processedContent" style="overflow: hidden;"></div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/api'
import { appOrPC, ipType, IMAGE_URL, interface_pubkey1, interface_prikey1 } from '@/utils/config';
export default {
  data() {
    return {
      news: {},
      searchId: "",
      searchTitle: "",
      type: "",
      areaCode: "",
      IMAGE_URL: IMAGE_URL,
      appOrPC: appOrPC,
      isLoading: true,
      processedContent: ""
    };
  },
  created() {
    this.news = JSON.parse(this.$route.params.detail)
    if (this.news.contents) {
      console.log('step1')
      // 删除包含"有声书链接"的标签
      this.processedContent = this.news.contents.replace(/有声书链接：/g, '').replace(/<a[^>]*>.*?<\/a>/g, '');
      console.log("this.processedContent:",this.processedContent);
      
      if (this.appOrPC) {
        this.processImages(this.processedContent)
      } else {
        this.isLoading = false;
      }
      
    }
  },
  mounted() {
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getImage(id) {
      let token = localStorage.getItem("token")
      return IMAGE_URL + `?id=${id}&token=${token}`
    },
    async getIMGURL(url, index, length) {
      console.log("step3:getIMGURL方法入口");
      try {
        const param = {
          ipType: ipType,
          methodType: "get",
          methodName: "getImageBase64",
          imgURL: url
        };
        let that = this
        await vaildInterfacefn(
          "hhwzzcsesonq",
          "rcshhwtyjkV0",
          JSON.stringify(param),
          "1"
        ).then((value) => {
          if (value == false) {
            that.getIMGURL(url, index, length)
            // throw new Error('获取图片失败');
          } else {
            try {
              const de_value = JSON.parse(value);
              console.log("step4:getIMGURL方法获取到图片");
              if (de_value.code === 200 && de_value.imageBase64) {
                const base64Image = "data:image/jpeg;base64," + de_value.imageBase64;
                that.processedContent = that.processedContent.replaceAll(url, base64Image)
                console.log("index:", index, "length:", length, index == length - 1)
                if (index == length - 1) {
                  that.isLoading = false
                  console.log("that.processedContent:", that.processedContent);
                }
              } else {
                // throw new Error(de_value.message || '获取图片失败');
                that.getIMGURL(url, index, length)
              }
            } catch (error) {
              console.error("获取图片error:", error);
              that.getIMGURL(url, index, length)
            }
          }
        })
      } catch (error) {
        console.error('获取图片失败:', error);
        // this.$toast.fail('获取图片失败');
        return require('@/assets/icon/noimage.png');
      }
    },
    async processImages(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const images = doc.querySelectorAll('img');
      console.log("step2");
      if (images.length == 0) {
        this.isLoading = false;
      } else {
        Array.from(images).map(async (img, index) => {
          const src = img.getAttribute('src');
          if (src) {
            try {
              await this.getIMGURL(src, index, images.length)
            } catch (error) {
              console.error('图片加载失败:', error);
              // img.setAttribute('src', require('@/assets/icon/noimage.png'));
            }
          }
        })
      }
      // return doc.body.innerHTML;
    },
  },
  watch: {
    // 监听news.contents变化
    // 'news.contents': {
    //   immediate: true, // 立即触发
    //   async handler(contents) {
    //     if (!this.appOrPC || !contents) {
    //       this.isLoading = false;
    //       this.processedContent = contents;
    //       return;
    //     }
    //     this.isLoading = true;
    //     const processed = await this.processImages(contents);
    //     this.processedContent = processed;
    //     this.isLoading = false;
    //   }
    // }
  },
  computed: {
    // processedContents() {
    //   console.log("Starting processedContents computation");
    //   console.log("appOrPC:", this.appOrPC);
    //   console.log("news.contents:", this.news.contents);

    //   if (!this.appOrPC || !this.news.contents) {
    //     console.log("Skipping image processing - appOrPC is false or no contents");
    //     // this.isLoading = false;
    //     return this.news.contents;
    //   }

    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(this.news.contents, 'text/html');
    //   const images = doc.querySelectorAll('img');
    //   console.log("Found", images.length, "images to process");

    //   images.forEach((img, index) => {
    //     const src = img.getAttribute('src');
    //     console.log(`Processing image ${index + 1} with src:`, src);
    //     if (src) {
    //       const base64 = this.getIMGURL(src);
    //       img.setAttribute('src', base64);
    //       console.log(`Updated image ${index + 1} src to base64`);
    //     }
    //   });

    //   // this.isLoading = false;
    //   console.log("Finished processing contents");
    //   return doc.body.innerHTML;
    // }
  },
};
</script>

<style scoped>
.van-nav-bar {
  background-color: #0081ff;
}

::v-deep(.van-nav-bar__title),
::v-deep(.van-nav-bar .van-icon),
::v-deep(.van-nav-bar__text) {
  color: #fffbf8;
}

.detail-right {
  text-align: right;
  font-size: 14px;
}
</style>
